import React, { useState, useEffect } from 'react';
import './LoadingSpinners.css';

// Animated Logo Spinner
export const LogoSpinner = () => {
  return (
    <div className="logo-spinner-container">
      <div className="logo-spinner">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="25" stroke="#A08EA8" strokeWidth="2" strokeDasharray="8 4" className="rotating-circle"/>
          <text x="30" y="38" textAnchor="middle" fill="#A08EA8" fontSize="24" fontWeight="bold">V</text>
        </svg>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

// Professional Circular Spinner
export const CircularSpinner = () => {
  return (
    <div className="circular-spinner-container">
      <div className="circular-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

// Pulsing Dots Spinner
export const DotsSpinner = () => {
  return (
    <div className="dots-spinner-container">
      <div className="dots-spinner">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

// Main Loading Spinner Component with Dynamic Settings
const LoadingSpinner = ({ type, isAdmin = false }) => {
  const [spinnerType, setSpinnerType] = useState(type || 'circular');
  
  useEffect(() => {
    // If type is explicitly provided, use it
    if (type) {
      setSpinnerType(type);
      return;
    }
    
    // Otherwise, fetch from settings
    const fetchSpinnerSettings = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${BACKEND_URL}/api/loading-spinner/settings`);
        
        if (response.ok) {
          const data = await response.json();
          // Use admin_spinner if in admin context, otherwise public_spinner
          const selectedSpinner = isAdmin ? data.admin_spinner : data.public_spinner;
          setSpinnerType(selectedSpinner || 'circular');
        }
      } catch (error) {
        console.error('Failed to load spinner settings:', error);
        // Fallback to circular if fetch fails
        setSpinnerType('circular');
      }
    };
    
    fetchSpinnerSettings();
  }, [type, isAdmin]);
  
  switch(spinnerType) {
    case 'logo':
      return <LogoSpinner />;
    case 'dots':
      return <DotsSpinner />;
    case 'circular':
    default:
      return <CircularSpinner />;
  }
};

export default LoadingSpinner;
